


























import Vue from 'vue'

import { ApiService } from '@/services'

import imageCompression from 'browser-image-compression'

export default Vue.extend({
  name: 'PhotoUpload',

  props: {
    photoType: {
      type: String,
      required: true,
      validator: function (value) {
        return ['proof', 'reverseFlowProof'].indexOf(value) !== -1
      },
    },
  },

  data: () => ({
    imageData: null,
    imagePreview: null,
    imageUploadProgress: -1,
    imageProgressAction: '',
  }),

  methods: {
    uploadImage: function () {
      this.imageUploadProgress = 0
      this.imageProgressAction = 'Uploading'

      ApiService.get(`signedUrl/${this.photoType}/${this.imageData.type.split('/')[1]}`)
        .then((response) => {
          return response.data
        })
        .then((signedUrlResponse) => {
          const requestConfig = {
            headers: { 'Content-Type': this.imageData.type },
            onUploadProgress: (progressEvent) => {
              this.imageUploadProgress = (progressEvent.loaded / progressEvent.total) * 100
            },
          }

          return ApiService.customRequest()
            .put(signedUrlResponse.signedUrl, this.imageData, requestConfig)
            .then(() => {
              this.$emit('photo-upload-complete', signedUrlResponse.publicUrl)
            })
        })
        .catch(() => {
          this.imageUploadProgress = -1
          this.imageProgressAction = ''

          this.$toast.error('Error Uploading Photo')
        })
    },
    chooseImage: function () {
      const fileInput = this.$refs.fileInput
      fileInput.click()
    },
    onFileSelected: function (event) {
      if (!event.target.files || !event.target.files[0]) {
        this.$toast.error('Error Uploading Photo')
        return
      }

      this.imageProgressAction = 'Generating Preview'

      imageCompression(event.target.files[0], {
        maxSizeMB: 1,
        maxWidthOrHeight: 1920,
        onProgress: (progress) => {
          this.imageUploadProgress = progress
        },
      })
        .then((response) => {
          this.imageData = response

          imageCompression.getDataUrlFromFile(this.imageData).then((response) => {
            this.imagePreview = response
            this.imageUploadProgress = -1

            this.$emit('photo-upload-selected')
          })
        })
        .catch(() => {
          this.$toast.error('Error Uploading Photo')
        })
    },
  },
})
